import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import SingleSelect from '../../common/Forms/SingleSelect';

const JobQuerySelect = ({ options, selectedValue }) => {
  const [selectedOption, setSelectedOption] = useState(selectedValue);

  const handleChange = (options) => {
    setSelectedOption(options);
  };

  return (
    <Fragment>
      <input name={selectedOption && `q[${selectedOption.value}]`}
             value='true'
             hidden/>

      <input name='q[job_query]'
             value={selectedOption && selectedOption.value}
             hidden/>
      <SingleSelect
        handleChange={handleChange}
        options={options}
        selectedValue={selectedValue}
        showCheckbox={true}
        placeholderText='Select job query...'
      />
    </Fragment>
  );
};

JobQuerySelect.propTypes = {
  options: PropTypes.array,
  selectedValues: PropTypes.array
};

JobQuerySelect.defaultProps = {
  options: [{}],
  selectedValues: [{}]
};

export default JobQuerySelect;
